import { useParams } from "react-router";

import { Container } from "@material-ui/core";

import { ContentSection } from "../../../../layout/ContentSection";
import { TitleHeader } from "../../../../components/TitleHeader";
import { LinearProgress } from "../../../../components/LinearProgress";
import { BackButton } from "../../../../components/BackButton";
import { useCustomerComments } from "../../../../comment/comments.hook";
import { ActivitySection } from "../../../../comment/ActivitySection";
import { CustomerCommentList } from "../../../../comment/CustomerCommentList";
import { useAddCustomerComment } from "../../../../comment/add-comment.hook";
import { useTask } from "../../../../task/tasks.hook";
import { NotFoundPage } from "../../../../NotFoundPage";
import { ErrorPage } from "../../../../ErrorPage";
import { TakePaymentTaskContext } from "./TakePaymentTaskContext";
import { TakePaymentTaskDocument } from "../../../../task/task.model";

interface TakePaymentDetailPageProps {
    goBack: () => void;
}

export const TakePaymentDetailPage = (props: TakePaymentDetailPageProps) => {
    const { goBack } = props;

    const { taskId } = useParams<{ taskId: string }>();
    const task = useTask(taskId) as TakePaymentTaskDocument | null | undefined;

    const comments = useCustomerComments(task?.customerId);
    const addComment = useAddCustomerComment(task?.customerId);

    if ( task === null ) return <NotFoundPage />;
    if ( task === undefined ) return <LinearProgress />;
    if ( task.type !== "take-payment" ) return <ErrorPage message="Opgavens type genkendes ikke" />;

    if ( comments === undefined ) return <LinearProgress />;

    const backButton = <BackButton onClick={goBack} />;

    return (
        <>
            <TitleHeader button={backButton}>Automatisk håndtering</TitleHeader>
            
            <ContentSection>
                <Container maxWidth="sm" disableGutters>

                    <TakePaymentTaskContext task={task} />

                    <ActivitySection onSave={addComment}>
                        <CustomerCommentList comments={comments} />
                    </ActivitySection>

                </Container>
            </ContentSection>
        </>
    );
};
